<!-- VerificationForm.vue -->
<template>
    <div class="form-container">
        <h2>Inscription</h2>
        <br>
        <form @submit.prevent="registerUser">
            <div class="form-control">
                <label for="password">Mot de passe:</label>
                <input type="password" id="password" v-model="password" required />
            </div>
            <div class="form-control">
                <label for="firstname">Prénom:</label>
                <input type="text" id="firstname" v-model="firstname" required v-alpha-numeric />
            </div>
            <div class="form-control">
                <label for="lastname">Nom:</label>
                <input type="text" id="lastname" v-model="lastname" required v-alpha-numeric />
            </div>
            <div v-if="errorMessage" :class="{ errorMessage: true, error: !isSuccess }">{{ errorMessage }}</div>
            <button type="submit" class="button fill normal" :disabled="isSubmitting">S'inscrire</button>
        </form>
    </div>
</template>


<script>
export default {
    data() {
        return {
            password: "",
            firstname: "",
            lastname: "",
            isSubmitting: false,
            isSuccess: false,
            errorMessage: "",
            md5: this.$route.params.md5,
        };
    },
    mounted() {
        this.md5 = this.$route.params.md5 || this.$route.query.md5;
    },
    methods: {
        async registerUser() {
            this.errorMessage = "";
            this.isSuccess = false;
            this.isSubmitting = true;

            try {
                const body = JSON.stringify({ md5: this.md5, password: this.password, firstname: this.firstname, lastname: this.lastname, })
                const response = await fetch(process.env.VUE_APP_API_URL + "user/register", { method: "POST", headers: { "Content-Type": "application/json" }, body, });
                const data = await response.json();

                this.isSubmitting = false;
                if (data.error) {
                    this.errorMessage = data.error;
                    this.isSuccess = false;
                } else {
                    this.isSuccess = true;
                    this.isSubmitting = true;
                    this.errorMessage = data.message;
                    setTimeout(() => {
                        this.$router.push("/login");
                    }, 300);
                }
            } catch (error) {
                this.errorMessage = "Une erreur technique est survenue.";
                this.isSuccess = false;
                this.isSubmitting = false;
            }
        },
    },
};
</script>
